import React, {Component} from "react";
import { useStyles } from './styles';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, withStyles} from "@material-ui/core";
import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import {ruRU,enUS } from '@material-ui/core/locale';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import Avatar from '@material-ui/core/Avatar';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import Client from '../../store/Model/Client';
import apiStore from "../../store/ApiStore";
import moment from "moment";
import {millisecondsToHms, filterEquals} from '../../lib/helper';
import Pagination from '@material-ui/lab/Pagination';
import TablePagination from '@material-ui/core/TablePagination';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputBase from "@material-ui/core/InputBase/InputBase";
import { useTranslation } from 'react-i18next';
import {Trans, Translation} from "react-i18next";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { getColleagues, actionColleagues, deleteColleagues, addColleague, updateColleague} from '../../actions/colleagueActions'
import { connect } from "react-redux";
import {getVerifys} from "../../actions/verifyActions";
import SearcherField from "../shared/SearcherField/SearcherField";
import Button from "@material-ui/core/Button";
import DateRangeIcon from '@material-ui/icons/DateRange';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import i18n from "../../services/i18n";
import Typography from "@material-ui/core/Typography";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import EditIcon from '@mui/icons-material/Edit';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';

import {NotificationManager} from "react-notifications";
import AdornmentPasswordField from "../LoginForm/AdornmentPasswordField";
import Alert from "@material-ui/lab/Alert/Alert";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import CurrencyDollarsIcon from '@mui/icons-material/AttachMoney';
import CurrencyEuroIcon from '@mui/icons-material/Euro';
import DatePickerRange from "../shared/DatePickerRange/DatePickerRange";


const theme = createTheme(
	{
		palette: {
			primary: { main: '#fff' },
		},
		root: {

		},

		cell: {
			border:0
		}
	},
	ruRU,
);

const BootstrapInput = withStyles((theme) => ({
	root: {
		'label + &': {
			marginTop: theme.spacing(3),
		},
	},
	input: {
		borderRadius: 4,
		position: 'relative',
		backgroundColor: theme.palette.background.paper,
		border: '1px solid #ced4da',
		fontSize: 16,
		padding: '10px 26px 10px 12px',
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		// Use the system font instead of the default Roboto font.
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		'&:focus': {
			borderRadius: 4,
			borderColor: '#80bdff',
			boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
		},
	},
}))(InputBase);

class TariffsList extends Component {

	state = {
		errorRegistr: [],
		loading: false,
		rows: [],
		selectRow: null,
		totalRows: 0,
		rowsPerPageOptions: [10, 20, 50, 100],
		pageSize: 10,
		page: 1,
        selectedRows: [],
        arList: [],
		arUsers: [],
		select: null,
		search: null,
		target: null,
		currency: null,
		sortBy: 'updated',
		sortDesc: true,
		error: {
			isErrorDisplayed: false,
			errorMessage: ''
		},
		toDateDefault: moment(new Date()).format("YYYY-MM-DD") , //"2024-05-21"
		fromDateDefault: moment(new Date()).format("YYYY-MM-DD"),//"2024-05-21"


		uid: null,
		user_u: null,
	};

	handleSearchChange = (event) => {
		let { name, value } = event.target;
		// console.log("handleSearchChange: ", value);
		this.setState({search:value, page: 1, sortBy: 'updated', sortDesc: true});
		this.loadList(this.state.fromDate, this.state.toDate, value, this.state.target, this.state.currency);
	};
	handleSearchKeyDown = (event) => {
		let { name, value } = event.target;
		// console.log('handleSearchKeyDown: ', value);
		if (event.key  === "Enter") {
			// console.log('handleSearchKeyDown: Enter');
			// request api with search
			this.setState({search:value});
			this.loadList(this.state.fromDate, this.state.toDate, value, this.state.target, this.state.currency);
		}
	};
	handleSearchClick = () => {
		// console.log('handleSearchClick: ', this.state.search);
		// request api with search
		this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency);
	};

    handleClearAllClick = () => {
        this.setState({
            search: null, target: null, currency: null, page: 1, sortBy: null, sortDesc: true, fromDate: null, toDate: null
        }, () => {
            // console.log("handleClearAllClick: ", this.state.search);
			this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency);
        })
    };

	handleSaveDateDialog = () => {
		// console.log("handleSaveDateDialog: ");
		this.setState({
			isOpenDateDialog: false,
			fromDatePrevios: this.state.fromDate,
			toDatePrevios: this.state.toDate
		}, () => {
			this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency);
		})
	};
	handleCloseDateDialog = () => {
		// console.log("handleCloseDateDialog: ");
		this.setState({
			isOpenDateDialog: false,
			fromDate: this.state.fromDatePrevios,
			toDate: this.state.toDatePrevios
		});
	};
	handleClickDateDialog = () => {
		// console.log("handleClickDateDialog: ");
		this.setState({
			isOpenDateDialog: true,
			fromDate: this.state.fromDateDefault,
			toDate: this.state.toDateDefault
		});
	};
	handleSetDateFrom = (value) => {
		// console.log("handleSetDateFrom, value: ", value);
		this.setState({fromDate: value});
		if(new Date(value).getTime() > new Date(this.state.toDate).getTime())  {
			this.setState({toDate: value});
		}
	};
	handleSetDateTo = (value) => {
		// console.log("handleSetDateTo, value: ", value);
		this.setState({toDate: value});
		if(new Date(value).getTime() < new Date(this.state.fromDate).getTime())  {
			this.setState({fromDate: value});
		}
	};

	handleTextChange = (event) => {
		let val = {};
		val[event.target.name] = event.target.value;
		// console.log('handleTextChange: ', val);
		this.setState(val);
	};
/*
	handleSetDateFrom = (value) => {
		// console.log("handleSetDateFrom, value: ", value);
		this.setState({fromDate: value});
		if(new Date(value).getTime() > new Date(this.state.toDate).getTime())  {
			this.setState({toDate: value});
		}
	};
	handleSetDateTo = (value) => {
		// console.log("handleSetDateTo, value: ", value);
		this.setState({toDate: value});
		if(new Date(value).getTime() < new Date(this.state.fromDate).getTime())  {
			this.setState({fromDate: value});
		}
	};*/



	loadList = async (fromDate = null, toDate = null, search = null, target = null, currency = null) => {
		// search = search ?? this.state.search;
		await apiStore.getListTariffs(this.state.page * 1 - 1, this.state.pageSize, this.state.sortBy, this.state.sortDesc, fromDate, toDate, search, target, currency).then(data => {
			this.setState({arList: data.data, totalRows: data.meta.quantity*1});
			//console.log("loadList, data: ", data);
		});
	};

	columns = [
		{ field: "payment_target_name", headerName: <Trans i18nKey={"TariffName"} >{"TariffName"}</Trans>, width: 180, renderCell: (params) => {
				return params.row.payment_target_name;
			},
			renderHeader: (props) => {
				return  <>
					<span onClick={(event) =>
						this.setState({sortBy: 'payment_target_name', sortDesc: (this.state.sortBy === null ? true : !this.state.sortDesc)}, () => {
							this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency)
						})} >
                        <Trans i18nKey={"TariffName"} >{"TariffName"}</Trans>
						{this.state.sortBy === 'payment_target_name' ? <>{this.state.sortDesc ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>}</>: ''}
					</span>
					<FormControl variant="standard" className={"input"}>
						<Select
							key={"payment_target_name"}
							variant={"standard"}
							className={"underlineselect"}
							displayEmpty
							value={this.state.target ? this.state.target : ""}
							onChange={
								event	=> {
									const target_name = event.target.value === "" ? null : event.target.value;
									this.setState({target:target_name}, () => {
										this.loadList(this.state.fromDate, this.state.toDate, this.state.search, target_name, this.state.currency);
									})
								}
							}
							input={<BootstrapInput />}
						>
							<MenuItem value="" key="DoesNotMatter" >
								<Trans i18nKey={"DoesNotMatter"}>{"DoesNotMatter"}</Trans>
							</MenuItem>
							<MenuItem value={"VOICE_ID"} key="VOICE_ID" ><Trans i18nKey={"VOICE_ID"} >{"VOICE_ID"}</Trans></MenuItem>
							<MenuItem value={"VOICE_EN"} key="VOICE_EN" ><Trans i18nKey={"VOICE_EN"} >{"VOICE_EN"}</Trans></MenuItem>
						</Select>
					</FormControl>
				</>
			},
			sortable: false
		},
		{ field: "payment_currency_u", headerName: <Trans i18nKey={"Currency"} >{"Currency"}</Trans>, width: 180, GridColType: 'string', renderCell: (params) => {
				switch (params.row.payment_currency_u) {
					case "68377f72-363c-11f0-828a-00163cd7dafc": // RUBLE
						return (
							<div className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }}>
								<CurrencyRubleIcon fontSize="small" style={{marginBottom: -5}} />
							</div>
						);
					case "0f83379e-363d-11f0-828a-00163cd7dafc": // EURO
						return (
							<div className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }}>
								<CurrencyEuroIcon fontSize="small" style={{marginBottom: -5}} />
							</div>
						);
					case "096d1f8c-363d-11f0-828a-00163cd7dafc": // DOLLAR
						return (
							<div className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }}>
								<CurrencyDollarsIcon fontSize="small" style={{marginBottom: -5}} />
							</div>
						);
					default:
						return '?';
				}
			},
			renderHeader: (props) => {
				return  <>
                    <span onClick={(event) =>
						this.setState({sortBy: 'payment_currency_u', sortDesc: (this.state.sortBy === null ? true : !this.state.sortDesc)}, () => {
							this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency)
						})} >
						<Trans i18nKey={"Currency"} >{"Currency"}</Trans>
						{this.state.sortBy === 'payment_currency_u' ? <>{this.state.sortDesc ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>}</>: ''}
					</span>
					<FormControl variant="standard" className={"input"}>
						<Select
							key={"payment_currency"}
							variant={"standard"}
							className={"underlineselect"}
							displayEmpty
							value={this.state.currency ? this.state.currency : ""}
							onChange={
								event	=> {
									const currency_name = event.target.value === "" ? null : event.target.value;
									this.setState({currency:currency_name}, () => {
										this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, currency_name);
									})
								}
							}
							input={<BootstrapInput />}
						>
							<MenuItem value="" key="DoesNotMatter" >
								<Trans i18nKey={"DoesNotMatter"}>{"DoesNotMatter"}</Trans>
							</MenuItem>
							<MenuItem value={"RUBLE"} key="RUBLE" >
								<CurrencyRubleIcon fontSize="small" style={{marginBottom: -5}} />
							</MenuItem>
							<MenuItem value={"EURO"} key="EURO" >
								<CurrencyEuroIcon fontSize="small" style={{marginBottom: -5}} />
							</MenuItem>
							<MenuItem value={"DOLLAR"} key="DOLLAR" >
								<CurrencyDollarsIcon fontSize="small" style={{marginBottom: -5}} />
							</MenuItem>
						</Select>
					</FormControl>
				</>
			},
			sortable: false
		},
        { field: "cost", headerName: <Trans i18nKey={"Cost"} >{"Cost"}</Trans>, width: 130, renderCell: (params) => {
                return params.row.cost;
            }, sortable: false,
            renderHeader: (props) => {
                return  <>
					<span onClick={(event) =>
						this.setState({sortBy: 'cost', sortDesc: (this.state.sortBy === null ? true : !this.state.sortDesc)}, () => {
							this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency)
						})} >
                        <Trans i18nKey={"Cost"} >{"Cost"}</Trans>
                        {this.state.sortBy === 'cost' ? <>{this.state.sortDesc ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>}</>: ''}
					</span>
					<div className={"input"}>
					</div>
                </>
            }
        },
		{ field: "comments", headerName: <Trans i18nKey={"Comment"} >{"Comment"}</Trans>, width: 300, renderCell: (params) => {
				return params.row.comments;
			}, sortable: false,
			renderHeader: (props) => {
				return  <>
					<span onClick={(event) =>
						this.setState({sortBy: 'comments', sortDesc: (this.state.sortBy === null ? true : !this.state.sortDesc)}, () => {
							this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.currency)
						})} >
						<Trans i18nKey={"Comment"} >{"Comment"}</Trans>
						{this.state.sortBy === 'comments' ? <>{this.state.sortDesc ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>}</>: ''}
					</span>
					<div className={"input"}>
					</div>
				</>
			}
		},
        { field: "updated", headerName: <Trans i18nKey={"DateUpdated"} >{"DateUpdated"}</Trans>, width: 170, renderCell: (params) => {
                return moment(params.row.updated).format("YYYY-MM-DD HH:mm:ss");
            }, sortable: false,
            renderHeader: (props) => {
                return  <>
					<span onClick={(event) =>
						this.setState({sortBy: 'updated', sortDesc: (this.state.sortBy === null ? true : !this.state.sortDesc)}, () => {
							this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency)
						})} >
						<Trans i18nKey={"DateUpdated"} >{"DateUpdated"}</Trans>
                        {this.state.sortBy === 'updated' ? <>{this.state.sortDesc ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>}</>: ''}
					</span>
					<div className={"input"}>
					</div>
                </>
            }
        },
		{ field: "created", headerName: <Trans i18nKey={"DateCreated"} >{"DateCreated"}</Trans>, width: 170, renderCell: (params) => {
				return moment(params.row.created).format("YYYY-MM-DD HH:mm:ss");
			}, sortable: false,
			renderHeader: (props) => {
				return  <>
					<span onClick={(event) =>
						this.setState({sortBy: 'created', sortDesc: (this.state.sortBy === null ? true : !this.state.sortDesc)}, () => {
							this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency)
						})} >
						<Trans i18nKey={"DateCreated"} >{"DateCreated"}</Trans>
						{this.state.sortBy === 'created' ? <>{this.state.sortDesc ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>}</>: ''}
					</span>
					<div className={"input"}>
					</div>
				</>
			}
		}
	];

	customPagination = () => {
		return (<>
				<div style={{float: 'left'}} >
					<div  >
						<Pagination
							color="primary"
							variant="outlined"
							shape="rounded"
							count={Math.ceil(this.state.totalRows / this.state.pageSize)}
							page={this.state.page}
							onChange={(event, value) => {
								this.setState({page: value * 1}, () =>
									this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency))
							}}

						/>
					</div>
					<div style={{marginTop: '10px'}} >
                        ({(this.state.page-1) * this.state.pageSize} - {this.state.page * this.state.pageSize < this.state.totalRows ? (this.state.page * this.state.pageSize): this.state.totalRows}) / {this.state.totalRows}
					</div>
				</div>
				<div>
					<div style={{color: '#828d99', float:'left', marginRight: 10}}><Trans i18nKey={"NumberRecords"} >{"NumberRecords"}</Trans><br/>
						<Trans i18nKey={"OnPage"} >{"OnPage"}</Trans>:</div>
					<Select
						style={{}}
						value={this.state.pageSize}
						onChange={event=>{
							//console.log("onChange, pageSize: ", event.target.value);
							this.setState({page: 1, pageSize: event.target.value}, () =>
								this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency))}
						}
						input={<BootstrapInput />}
					>
						{this.state.rowsPerPageOptions.map(val=><MenuItem value={val} key={"NumberRecords " + val} >{val}</MenuItem>)}
					</Select>
				</div>
			</>
		);
	}

	onFilterModelChange = (model) => {
	//	for(let item of model.items){
	//		console.log(item);
	//	}
	}

	componentDidMount() {
		this.loadList();
	}

	renderDateDialog = () => {
		const {classes} = this.props;
		return <Dialog
			open={this.state.isOpenDateDialog}
			onClose={this.handleCloseDateDialog}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth={'md'}
		>
			<DialogTitle id="alert-dialog-title"><Trans i18nKey={"DateSelect"} >{"DateSelect"}</Trans></DialogTitle>
			<DialogContent>
				{/*<DialogContentText id="alert-dialog-description">
					</DialogContentText>*/}
				<Grid container  spacing={2} >
					<Grid item xs={12} md={4} lg={6} >
						<FormControl className={classes.formControl}>
							<DatePickerRange
								language={i18n.language}
								label={<Trans i18nKey={"DateFrom"} >{"DateFrom"}</Trans>}
								defaultValue={
									new Date(this.state.fromDateDefault).getTime() < new Date(this.state.toDate).getTime()
										? this.state.fromDateDefault : this.state.toDate
								}
								updateValue={this.handleSetDateFrom}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={12} md={4} lg={6} >
						<FormControl className={classes.formControl}>
							<DatePickerRange
								language={i18n.language}
								label={<Trans i18nKey={"DateTo"} >{"DateTo"}</Trans>}
								defaultValue={
									new Date(this.state.toDateDefault).getTime() > new Date(this.state.fromDate).getTime()
										? this.state.toDateDefault : this.state.fromDate
								}
								updateValue={this.handleSetDateTo}
							/>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={this.handleCloseDateDialog} color="secondary" >
					<Trans i18nKey={"Close"} >{"Close"}</Trans>
				</Button>
				<Button variant="outlined" onClick={this.handleSaveDateDialog} color="primary" autoFocus>
					<Trans i18nKey={"Save"} >{"Save"}</Trans>
				</Button>
			</DialogActions>
		</Dialog>
	};

	render() {
		//this.state.rows.slice(0, this.state.pageSize)
		const {classes} = this.props;

		return (
			<>
				{this.renderDateDialog()}

				<h2 style={{marginTop: 0, marginBottom: 20, marginLeft: 20}}>
					<Trans i18nKey={"Tariffs"} >{"Tariffs"}</Trans>,
					<label style={{marginTop: 0, marginBottom: 20, marginLeft: 10}}>
						{this.state.totalRows}
					</label>
				</h2>
				<SearcherField
					name="searcher"
					label={<Trans i18nKey={"Search"} >{"Search"}</Trans>}
					style={{marginTop: 0, marginLeft: 10, marginBottom: 24, width: '35%'}}
					value={this.state.search}
					onChange={this.handleSearchChange}
					onKeyDown={this.handleSearchKeyDown}
					onClick={this.handleSearchClick}
					isErrorDisplayed={this.state.error.isErrorDisplayed}
					errorMessage={this.state.error.errorMessage}
				/>
				<Button variant="outlined"
						endIcon = {<DateRangeIcon/>}
						style={{marginTop: 0, marginLeft: 40, marginBottom: 24}}
						onClick={this.handleClickDateDialog} color="primary" >
					{this.state.fromDate ? moment(this.state.fromDate).format("YYYY-MM-DD") : ""}
					&nbsp; - &nbsp;
					{this.state.toDate ? moment(this.state.toDate).format("YYYY-MM-DD") : ""}
				</Button>
                <Button variant="outlined"
                        startIcon = {<FilterAltOffIcon/>}
                        style={{marginTop: 0, marginLeft: 10, marginBottom: 24}}
                        onClick={this.handleClearAllClick} color="primary" >
                    <Trans i18nKey={"Clear"} >{"Clear"}</Trans>
                </Button>

				<ThemeProvider
					theme={theme}
				>
					<div className={classes.root} >
						<DataGrid getRowId={(row) => row.uid}
								  loading={this.state.loading}
								  rows={this.state.arList}
								  columns={this.columns}
								  // checkboxSelection
								  disableSelectionOnClick
								  components={{
									// FilterPanel: null,
									Pagination: this.customPagination
									}}
								  rowHeight={50}
								  pagination
								  paginationMode="server"
								  onSelectionModelChange={(data) => {
                                		// console.log("onSelectionModelChange, data: ", data);
                                		this.setState({selectedRows: data})
								  }}
								  onPageChange={(data) => {
										this.setState({page: data * 1 }, () =>
											this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency));
								  }}
								  onPageSizeChange={(data) => {
									//console.log("pageSize: ", data);
									this.setState({page: 1, pageSize: data}, () =>
										this.loadList(this.state.fromDate, this.state.toDate, this.state.search, this.state.target, this.state.currency));
								  }}
						/>
					</div>
				</ThemeProvider>
			</>
		);
	}
}


const mapStateToProps = state => {
	return state;
};

const mapDispatchToProps = {

};

export default withStyles(useStyles)(connect(mapStateToProps, mapDispatchToProps)(TariffsList));
